import { kemsuWebSystemBridgeUrl } from "~/shared/api/kemsuweb"
import { ignoreKemsuWebSystem } from "~/shared/config"
//import { checkKemsuWebSystemSessionValidity } from "~/domain/user-session"

/**
 * Аутентификация в системе на KemsuWeb
 * @param login логин
 * @param password пароль
 */
export function authenticateInKemsuWebSystem(
	login: string,
	password: string
): Promise<void> {
	if (ignoreKemsuWebSystem) return Promise.resolve()

	return new Promise((resolve, reject) => {
		const iframe = document.createElement("iframe")
		iframe.style.display = "none"
		iframe.name = Date.now().toString()
		iframe.src = `${kemsuWebSystemBridgeUrl}/auth.htm`

		document.body.appendChild(iframe)

		/*const handler = async (e) => {
			if (e.data !== "auth") return

			setTimeout(() => {
				iframe.parentNode?.removeChild(iframe)
				window.removeEventListener("message", handler)
				resolve()
			}, 1000)
		}*/

		let messagePosted = false

		iframe.addEventListener("load", async () => {
			if (!messagePosted) {
				console.log("Создание сессии на xiais.kemsu.ru...")
				messagePosted = true
				//window.addEventListener("message", handler, false)
				iframe.contentWindow?.postMessage(
					JSON.stringify({ login: login.trim(), password: password.trim() }),
					"*"
				)
			} else {
				console.log("Сессия на xiais.kemsu.ru создана")
				resolve()
				// TODO: ломается
				/*if (await checkKemsuWebSystemSessionValidity()) {
					console.log("Сессия на xiais.kemsu.ru создана")
					resolve()
				} else {
					console.log("Не удалось создать сессию на xiais.kemsu.ru")
					reject("Ошибка сервера. Попробуйте позднее или обратитесь в тех. поддержку системы")
				}*/

				iframe.parentNode!.removeChild(iframe)
			}
		})

		iframe.addEventListener("error", (err) => {
			iframe.parentNode!.removeChild(iframe)
			reject(err)
		})
	})
}
